// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"261": "4752969116ed","4004": "66f2b799903c","4022": "5997513562b9","6863": "454c9f289029","7141": "cdec85e31733",}[chunkId] + ".css"
}